const Checklist = require('./checklist.svg');
const Cinema = require('./cinema.svg');
const User = require('./user.svg');

export {
    Checklist,
    Cinema,
    User
}
